<template>
  <v-container
    class="main-container"
    fill-height
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <v-row justify="center" align="center">
      <v-col cols="8">
        <v-card color="grey lighten-3 pa-5">            
          <v-card-title class="justify-center">{{ $t('uploadXmlFile') }}</v-card-title>

          <v-file-input
            label="XML datoteka"
            @change="onChange"
            @click:clear="clearFileInput()"
            ref="fileInput"
            accept=".xml"
            outlined
            dense
          ></v-file-input>

          <v-row v-if="currentFile != undefined && showChoosedFile">
            <v-col cols="9">
              Izabrana datoteka: {{ currentFile.name }}
            </v-col>
          </v-row>

          <v-card-actions class="justify-center mt-5">
            <v-btn @click="uploadFile()">Učitaj datoteku</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--  No file chosen dialog  -->
    <v-dialog v-model="showNoChosenFileDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">
          Obaveštenje!
        </v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showNoChosenFileDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
    import { v4 as uuidv4 } from 'uuid'

    export default {
        name: "UploadXml",
        data() {
            return{
                message: "",
                currentFile: "",
                showNoChosenFileDialog: false,
                showChoosedFile: false,
            }
        },
        methods: {
            clearFileInput() {
                this.currentFile = "";
                this.showChoosedFile = false;
            },
            onChange(e) {
                let file = e;
                this.currentFile = file;
                this.showChoosedFile = true;
            },
            uploadFile() {
                if (
                    this.currentFile == "" ||
                    this.currentFile == null ||
                    this.currentFile == undefined
                ) {
                    this.message = "Molimo Vas izaberite xml datoteku.";
                    this.showNoChosenFileDialog = true;
                    return;
                }
                let requestId = uuidv4();
                var formData = new FormData();
                formData.append('file', this.currentFile);
                //formData.append('requestId', requestId);
                this.axios.post('SalesInvoices/UploadXml?requestId=' + requestId + '&organizationId=' + this.$store.getters.organizationId, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then((response) => {
                    if(response.data.message != null) {
                        this.message = response.data.message;
                        this.showNoChosenFileDialog = true;
                        return;
                    }
                    this.message = "Faktura broj " + response.data.invoice + " je poslata.";
                    this.showNoChosenFileDialog = true;
                    this.clearFileInput();
                }, (error) => {
                    console.log("Error: " + error);
                    console.log(error);
                })
            },
            dragover(event) {
                event.preventDefault();
                // Add some visual effects to show the user can drop its files
                if (!event.currentTarget.classList.contains("bg-green-300")) {
                    event.currentTarget.classList.remove("bg-gray-100");
                    event.currentTarget.classList.add("bg-green-300");
                }
            },
            dragleave(event) {
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
            drop(event) {
                event.preventDefault();

                this.onChange(event.dataTransfer.files[0]);
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
        }
    }
</script>

